module.exports = "<b> {{ 'periodic_tasks.task_details.repeat' | translate }}: </b>\n{{ TaskDetailsCtrl.taskDetails.repeater_config | frequencyDisplay }}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/app/components/periodic_tasks/task_details/display_frequency.html
// module id = 753
// module chunks = 0